/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetActivePaymentGatewayResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetActivePaymentGatewayResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/payments/gateway
 */
export interface GatewayRequestBuilder extends BaseRequestBuilder<GatewayRequestBuilder> {
    /**
     * Returns the provider name of the organization's active payment integration (e.g. AuthorizeNet, WorldPay), so clients can choose the matching add-card flow. Provider is null when no payment integration is enabled.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetActivePaymentGatewayResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<GatewayRequestBuilderGetQueryParameters> | undefined) : Promise<GetActivePaymentGatewayResponse | undefined>;
    /**
     * Returns the provider name of the organization's active payment integration (e.g. AuthorizeNet, WorldPay), so clients can choose the matching add-card flow. Provider is null when no payment integration is enabled.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<GatewayRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns the provider name of the organization's active payment integration (e.g. AuthorizeNet, WorldPay), so clients can choose the matching add-card flow. Provider is null when no payment integration is enabled.
 */
export interface GatewayRequestBuilderGetQueryParameters {
    /**
     * Optional: OrganizationId to switch to (must be in user's OrgCodes)
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const GatewayRequestBuilderUriTemplate = "{+baseurl}/api/payments/gateway{?useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GatewayRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GatewayRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetActivePaymentGatewayResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
